<template>
  <div class="">
    <component
      :is="toast.component"
      v-for="toast in toasts"
      :key="toast.id"
      v-bind="toast.props"
      @close="removeToast(toast.id)"
    />
  </div>
</template>

<script setup>
import { useStore } from 'vuex';
import { computed } from 'vue';

const store = useStore();
const toasts = computed(() => store.state.toast.toasts);
const removeToast = (id) => store.dispatch('toast/removeToast', id);
</script>
